exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SocialProof__container{height:auto}.SocialProof--title{letter-spacing:1px;text-align:center;margin-bottom:1.875rem;font-size:3.5rem;line-height:3.783rem}@media screen and (min-width: 47.0625em)and (max-width: 64em){.SocialProof--title{font-size:2.65rem}}@media screen and (max-width: 47.0625em){.SocialProof--title{font-size:2rem;text-align:left;letter-spacing:normal;line-height:2.6rem;margin-bottom:1.25rem}}", ""]);

// exports
